import { render, staticRenderFns } from "./ContentBlockFooter.vue?vue&type=template&id=2435ceaf&scoped=true"
import script from "./ContentBlockFooter.vue?vue&type=script&lang=js"
export * from "./ContentBlockFooter.vue?vue&type=script&lang=js"
import style0 from "./ContentBlockFooter.vue?vue&type=style&index=0&id=2435ceaf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2435ceaf",
  null
  
)

export default component.exports